import api from '@/billing/API';
import { PaymentMethod } from '@/type';

export function add(
  customerId: number,
  paymentMethodId: string,
  label?: string|null,
): Promise<PaymentMethod> {
  const url = `customers/${customerId}/payment-methods`;
  return api
    .post(url, { paymentMethodId, label })
    .then(response => response.data);
}

export function update(id: number, label: string|null): Promise<PaymentMethod> {
  return api
    .put(`payment-methods/${id}`, { label })
    .then(response => response.data);
}

export function remove(id: number): Promise<void> {
  return api.delete(`payment-methods/${id}`);
}
